// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2T0J7","btn-primary":"Button_btn-primary__sXJ_e","btn-secondary":"Button_btn-secondary__3IroL"};